module.exports = __webpack_public_path__ + "img/heng3.905cdf98.png";